import React from "react";
var logo = function logo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "46.6864344 16.6594399 31.0503552 0.142308743 0 0.142308743 17.1569945 16.6594399 46.6864344 16.6594399"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.1571448 38.4827186 0 54.9998497 31.0503552 54.9998497 46.6865847 38.4827186 17.1571448 38.4827186"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.9589071 0.142308743 44.2739481 10.1961885 50.3923224 16.6594399 67.8522678 16.6594399 85.0092623 0.142308743 53.9589071 0.142308743"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "67.8522678 38.4827186 50.3924727 38.4827186 44.2739481 44.9459699 53.9589071 54.9998497 85.0092623 54.9998497 67.8522678 38.4827186"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9.2865847 26.1618169 3.96030055 26.1618169 3.96030055 19.7484563 0.328497268 19.7484563 0.328497268 35.3937022 3.96030055 35.3937022 3.96030055 29.4618169 9.2865847 29.4618169 9.2865847 35.3937022 12.9407787 35.3937022 12.9407787 19.7484563 9.2865847 19.7484563 9.2865847 26.1618169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7478552,29.4618169 L21.4134836,24.1712978 L23.079112,29.4618169 L19.7478552,29.4618169 Z M19.4146995,19.7484563 L14.1249317,35.3937022 L17.8804098,35.3937022 L18.7754372,32.5508333 L24.0516803,32.5508333 L24.9467077,35.3937022 L28.7021858,35.3937022 L23.4176776,19.7484563 L19.4146995,19.7484563 L19.4146995,19.7484563 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "33.5405328 19.7484563 29.8863388 19.7484563 29.8863388 35.3937022 39.2092896 35.3937022 39.2092896 32.0935519 33.5405328 32.0935519 33.5405328 19.7484563"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.9043716 35.3937022 44.6022951 35.3937022 44.6022951 19.7484563 40.9043716 19.7484563"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "50.3404781 23.0486066 57.2244945 23.0486066 57.2244945 19.7484563 46.686735 19.7484563 46.686735 35.3937022 50.3404781 35.3937022 50.3404781 29.4618169 56.0445492 29.4618169 56.0445492 26.1618169 50.3404781 26.1618169 50.3404781 23.0486066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7301366,29.4618169 L63.395765,24.1712978 L65.0613934,29.4618169 L61.7301366,29.4618169 Z M84.285847,19.7484563 L80.1404098,19.7484563 L77.1956557,24.4753005 L74.2507514,19.7484563 L70.1054645,19.7484563 L75.2079918,27.5710792 L70.4867077,34.8089891 L65.399959,19.7484563 L61.3968306,19.7484563 L56.1070628,35.3937022 L59.862541,35.3937022 L60.7575683,32.5508333 L66.0339617,32.5508333 L66.9289891,35.3937022 L74.2507514,35.3937022 L77.1956557,30.6670082 L80.1404098,35.3937022 L84.285847,35.3937022 L79.1831694,27.5710792 L84.285847,19.7484563 L84.285847,19.7484563 Z"
  })))));
};
logo.defaultProps = {
  width: "85",
  height: "55",
  viewBox: "0 0 85 55",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
export default {
  base: logo,
  wide: logo
};